<template>

<div>

    <div id="modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" v-if="activeCard == 'new'">Skapa nytt klippkort</h4>
                    <h4 class="modal-title" v-else>Ändra klippkort</h4>
                </div>
                <div class="modal-body">

                    <div class="form-group" v-bind:class="{ 'has-error': errors['address']}">
                        <label class="control-label">Location</label>
                    	<div class="input-group">
                        	<input class="form-control" type="text" v-model="address_query" v-on:keyup="searchAddress" />
                        	<span class="input-group-addon">
                                <transition name="loader-fade">
                                    <i v-bind:class="groupAddon" aria-hidden="true"></i>
                                </transition>
                            </span>
                        </div>
                    </div>

                    <div class="autocompl-result-outer">
                        <div class="autocompl-result">
                            <div class="autocompl-row" v-for="address in addresses" v-on:click="selectAddress(address)">
                                <div style="float:left; width:35%; height:100%; margin-right:5%; overflow: hidden; white-space: nowrap; text-overflow:ellipsis;">{{ address.title }}</div>
                                <div style="float:left; width:55%; height:100%; margin-right:5%; overflow: hidden; white-space: nowrap; text-overflow:ellipsis;">{{ address.street }}, {{ address.city }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group" v-bind:class="{ 'has-error': errors['affiliate_id']}">
                        <label class="control-label">Inköpskanal</label>
                        <select class="form-control" v-model="affiliate_id" v-on:change="selectAffiliate()">
                            <option value="0">Välj</option>
                            <option v-for="affiliate in filteredAffiliates" v-bind:value="affiliate.id">{{ affiliate.name }}</option>
                        </select>
                        <div v-if="activeCard !== 'new'" style="width:100%; padding-top:8px;"><i>Notera att priset inte följer när du ändrar inköpskanal i efterhand. Vill du ändra pris på klippkortet? Ta då bort detta kort och lägg till ett nytt med rätt inköpskanal och produkt.</i></div>
                    </div>

                     <div class="form-group" v-bind:class="{ 'has-error': errors['account_id']}">
                        <label class="control-label">Konto</label>
                        <select class="form-control" v-model="account_id">
                            <option value="0">Välj</option>
                            <option value="4">3310</option>
                            <option value="1">3012</option>
                            <option value="2">3011</option>
                        </select>
                    </div>

                    <div class="form-group" v-if="activeCard == 'new'" v-bind:class="{ 'has-error': errors['product_id']}">
                        <label class="control-label">Produkt</label>
                        <select class="form-control" v-model="product_id" v-on:change="selectProduct()">
                            <option value="0">Välj</option>
                            <option v-for="product in filteredProducts" v-bind:value="product.id">
                            {{ product.name }}
                            {{ product.duration.minutes }} minuter
                            {{ product.punches }} klipp
                            </option>
                        </select>
                    </div>

                    <div class="form-group" v-bind:class="{ 'has-error': !card.price && errors['price']}" v-if="activeCard == 'new'">
                        <label class="control-label">Pris</label>
                        <br />
                        <span v-if="card.price">{{ card.price }} kr</span>
                        <span style="color: red;" v-if="!card.price && errors['price']">Produkten har inget angivet pris för den valda inköpskanalen!</span>
                    </div>

                    <div class="form-group">
                        <label class="control-label">Gäller till</label>
                        <datepicker
                            language="sv"
                            input-class="form-control"
                            v-on:selected="selectDate"
                            :format="date_format"
                            :value="date_start">
                        </datepicker>
                    </div>

                    <div class="form-group" v-if="activeCard == 'new'">
                        <label class="control-label">Antal klipp</label>
                        <input type="text" class="form-control" v-model="card.punches_total" />
                    </div>

                    <div class="form-group">
                        <label class="control-label">Ordernummer</label>
                        <input type="text" class="form-control" v-model="card.order_number" />
                    </div>

                    <div v-if="card.affiliate && !card.affiliate.self_invoice">

                        <div class="form-group">
                            <label class="control-label">Ref nr eller annat som ska anges på fakturan</label>
                            <input type="text" class="form-control" v-model="card.reference" />
                        </div>

                    </div>

                    <div class="form-group">
                        <label class="control-label">Text</label>
                        <input type="text" class="form-control" v-model="card.text" />
                    </div>

                    <div class="form-group" v-if="activeCard == 'new'">
                        <input type="checkbox" id="checkbox_is_gift" v-model="card.is_gift" />
                        <label class="control-label" for="checkbox_is_gift">Presentkort</label>
                    </div>

                    <div v-if="activeCard === 'new' && card.is_gift">
                        <div class="form-group">
                            <label class="control-label">Hälsning till mottagaren</label>
                            <textarea class="form-control" v-model="card.gift_greeting"></textarea>
                        </div>
                        <div class="form-group">
                          <label class="control-label">När ska det skickas?</label>

                          <div style="display:flex;">
                            <div style="width:50%; box-sizing:border-box;">
                              <datepicker
                                language="sv"
                                input-class="form-control"
                                v-on:selected="selectDateGift"
                                :format="date_format">
                              </datepicker>
                            </div>
                            <div style="width:50%; box-sizing:border-box;">
                                <input type="time" class="form-control" v-model="card.gift_activation_at_time" />
                            </div>
                          </div>

                          <span style="color: red;" v-if="errors['gift_activation_at']">Välj ett datum och tid</span>

                        </div>

                    </div>

                    <div class="form-group" v-if="activeCard == 'new'">
                        <input type="checkbox" id="checkbox_is_manual" v-model="card.is_manual" />
                        <label class="control-label" for="checkbox_is_manual">Manuellt klippkort</label>
                    </div>

                    <div class="form-group" v-if="activeCard == 'new'">
                        <input type="checkbox" id="checkbox_send_mail" value="1" :disabled="!customer.email" v-model="card.send_mail" />
                        <label class="control-label" for="checkbox_send_mail">Skicka e-post</label>
                    </div>

                    <div class="alert alert-warning" v-show="validationError">
                        Du måste fylla i alla rödmarkerade fält.
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-info" data-dismiss="modal">Avbryt</button>
                    <button type="button" class="btn btn-primary" v-on:click="createCard()">Spara</button>
                </div>
            </div>
        </div>
    </div>

</div>

</template>

<script>
export default {

    props: {
        activeCard: {

        },

        customer: {

        },

        affiliates: {

        },

        products: {

        },

        preselectAddress: {

        }
	    },

	    data: function () {
        return {

            test: {},

            date_format: 'yyyy-MM-dd',
            date_init: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
            date_start: this.date_init,

            loading: 0,
            done: 0,
            address_query: null,
            addresses: {},

            affiliate_id: 0,
            product_id: 0,
            account_id: 0,

            validationError: false,
            errors: {},

            card: {
                id: 0,
                address: null,
                affiliate: null,
                account: null,
                product: null,
                valid_to: null,
                punches_total: null,
                order_number: null,
                text: null,
                reference: null,
                is_manual: null,
                send_mail: null,
                price: null,
                is_gift: false,
                gift_greeting: '',
                gift_activation_at_date: '',
                gift_activation_at_time: '09:00'
            }
        }
    },

    methods: {

        createCard: function () {
            let mode = 'new'
            if (this.activeCard != 'new') {
                mode = 'update'
            }

            this.errors = {}

            if (this.affiliate_id == 0) {
                this.errors.affiliate_id = true
            }
            if (this.product_id == 0) {
                this.errors.product_id = true
            }
            if (this.account_id == 0) {
                this.errors.account_id = true
            }
            if (this.card.address == null) {
                this.errors.address = true
            }
            if (this.card.price == null) {
                this.errors.price = true
            }

            if (this.activeCard === 'new' && this.card.is_gift) {
                if (!/(\d{4}-\d{2}-\d{2} \d{2}:\d{2})+/g.test(this.card.gift_activation_at_date + ' ' + this.card.gift_activation_at_time)) {
                    this.errors.gift_activation_at = true
                }
            }

            if (_.size(this.errors) > 0) {
                this.validationError = true

                console.log('validation failed')
                return false
            }

            this.$emit('saveCard', this.card, mode)
        },

        searchAddress: function () {
            const self = this

            self.loading = 1

            this.done = 0

            self.card.address = null

            if (!self.address_query) {
                self.loading = 0
                self.addresses = []
                return
            }

            this.$http.post('/cards/searchAddress', { query: this.address_query }).then((response) => {
                console.log(response.body)

                self.loading = 0

                self.addresses = response.body
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        selectAddress: function (address) {
            this.done = 1

            if (address) {
                this.address_query = address.title
                this.card.address = address
            } else {
                this.address_query = ''
                this.card.address = null
            }

            this.addresses = []
        },

        selectAffiliate: function () {
            const self = this

            let affiliate = this.affiliates.filter(function (element) {
                return element.id === self.affiliate_id
            })

            affiliate = affiliate[0]

            self.account_id = affiliate.account_id

            self.card.affiliate = affiliate

            console.log('card product after change')
            console.log(self.card.affiliate)

            if (this.activeCard === 'new') {
                self.getPrice()
            }
        },

        selectProduct: function () {
            const self = this

            let product = this.products.filter(function (element) {
                return element.id === self.product_id
            })

            product = product[0]

            self.card.product = product

            console.log('card product after change')
            console.log(self.card.product)

            self.card.punches_total = self.card.product.punches

            if (this.activeCard === 'new') {
                self.getPrice()
            }
        },

        selectDate: function (test) {
            console.log('date changed')
            console.log(test)

            console.log('moment date')
            console.log(moment(test).format('YYYY-MM-DD'))

            this.card.valid_to = moment(test).format('YYYY-MM-DD')
        },

        selectDateGift: function (test) {
            console.log('date changed')
            console.log(test)

            console.log('moment date')
            console.log(moment(test).format('YYYY-MM-DD'))

            this.card.gift_activation_at_date = moment(test).format('YYYY-MM-DD')

            this.card.valid_to = moment(test).add('1', 'year').format('YYYY-MM-DD')
            this.date_start = moment(test).add('1', 'year').toDate()
        },

        getPrice: function () {
            const self = this

            console.log('compute price')

            const affiliate_id = self.affiliate_id
            const product_id = self.product_id

            console.log('affiliate_id')
            console.log(affiliate_id)

            console.log('product_id')
            console.log(product_id)

            this.$http.post('/cards/getPrice', { affiliate_id: affiliate_id, product_id: product_id }).then((response) => {
                console.log(response.body)

                if (response.body != null) {
                    self.card.price = response.body.price
                } else {
                    self.card.price = null
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        }

	    },
    computed: {
        groupAddon: function (type) {
            if (this.loading == 1) {
                return 'fa fa-cog fa-spin'
            }

            if (this.done == 1) {
                return 'fa fa-check'
            }

            return 'fa fa-search'
        },

        filteredAffiliates () {
            const affiliates = this.affiliates.filter((affiliate) => {
                return affiliate.is_active == true
            })

            return _.orderBy(affiliates, ['name'], ['asc'])
        },

        filteredProducts () {
            if (!this.affiliate_id) {
                return this.products
            }

            const affiliate = this.affiliates.find(a => a.id === this.affiliate_id)

            return this.products.filter(p => p.product_area_id === affiliate.product_area_id)
        }

    },
    watch: {
        activeCard: function (data) {
            console.log('date init')
            console.log(this.date_init)

            this.validationError = false
            this.errors = {}

            if (data != 'new') {
                this.date_start = moment(data.valid_to).toDate()

                this.card.id = data.id
                this.card.order_number = data.order_number
                this.card.text = data.text
                this.card.reference = data.reference
                this.card.valid_to = moment(data.valid_to).format('YYYY-MM-DD')
                this.card.price = data.price
                this.card.is_gift = data.is_gift
                this.card.gift_greeting = data.gift_greeting

                this.product_id = data.product.id

                this.affiliate_id = data.affiliate.id

                this.selectAddress(data.address)
                this.selectProduct()
                this.selectAffiliate()

                this.account_id = data.account.id
            } else {
                this.date_start = moment(this.date_init).toDate()

                this.card.id = 0
                this.card.order_number = ''
                this.card.text = ''
                this.card.reference = ''
                this.card.valid_to = moment(this.date_init).format('YYYY-MM-DD')
                this.card.price = null
                this.card.send_mail = (!this.customer.phone && this.customer.email ? true : null)
                this.card.is_gift = false
                this.card.gift_greeting = ''
                this.card.gift_activation_at_date = ''
                this.card.gift_activation_at_time = '09:00'

                this.product_id = 0

                this.affiliate_id = 0
                this.account_id = 0

                if (this.preselectAddress) {
                    // Trigger new commit
                    this.selectAddress(this.preselectAddress)
                } else {
                    this.address_query = ''
                    this.card.address = null
                    this.done = 0
                }
            }
        },
        account_id: function () {
            this.card.account = this.account_id
        }
    }

}
</script>
